var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAddEmail(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 16 15.42",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_43226",
    "data-name": "Group 43226",
    transform: "translate(-385 -523)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_43037",
    "data-name": "Group 43037",
    transform: "translate(385 523)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_14954",
    "data-name": "Rectangle 14954",
    fill: "none"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M12.521,7.647V9.732H10.434v1.39h2.087v2.085h1.391V11.123H16V9.732H13.912V7.647ZM9.043,9.732H1.391V2.781L6.956,6.256l5.565-3.476V6.256h1.391V1.39A1.4,1.4,0,0,0,12.521,0H1.391A1.4,1.4,0,0,0,0,1.39V9.732a1.4,1.4,0,0,0,1.391,1.39H9.043ZM12.521,1.39,6.956,4.866,1.391,1.39Z",
    transform: "translate(0.001 1.392)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAddEmail);
export default __webpack_public_path__ + "static/media/add-email.36d9ec0578d4331ae15359c16fd3c331.svg";
export { ForwardRef as ReactComponent };